export const SFREP_FNMA_1004_FORM_CODE = 'FNMA-1004-0911';
export const SFREP_FNMA_1004_ADDITIONAL_COMPS_FORM_CODE = 'FNMA-1004-0911-SalesComps';

export const SFREP_FNMA_2055_FORM_CODE = 'FNMA-2055-0911';
export const SFREP_FNMA_2055_ADDITIONAL_COMPS_FORM_CODE = 'FNMA-2055-0911-SalesComps';

export const SFREP_FNMA_1004C_ADDITIONAL_COMPS_FORM_CODE = 'FNMA-1004C-0305-SalesComps';

export const SFREP_FNMA_1025_FORM_CODE = 'FNMA-1025-0305';
export const SFREP_FNMA_1025_ADDITIONAL_COMPS_FORM_CODE = 'FNMA-1025-0305-SalesComps';
